import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ClientState {
  client: Parameter[];
  setClient: (newClient: Parameter[] | undefined) => void;
}

export const useClientStore = create<ClientState>()(
  devtools(
    (set) => ({
      client: [],
      setClient: (newClient) =>
        set(() => ({
          client: newClient ? [...newClient] : [],
        })),
    }),
    { name: "ClientStore" }
  )
);
